import { type PortableTextTypeComponentProps } from '@portabletext/react';
import { type FC } from 'react';

import { type LelandTable } from '../../../types/cmsTypes';

export const LELAND_TABLE_TYPE = 'lelandTable';

export type LelandTableProps = LelandTable;

const LelandTable: FC<PortableTextTypeComponentProps<LelandTableProps>> = ({
  value: {
    table,
    headerCol: isFirstColHeader,
    headerRow: isFirstRowHeader,
  } = {},
}) => {
  if (!table?.rows.length) return null;

  const commonCellClassName = 'min-w-33 border border-leland-gray-stroke p-2.5';
  const headerCellClassName =
    'bg-leland-gray-hover text-leland-gray-dark font-medium';

  const headerRow = isFirstRowHeader ? table.rows[0] : null;
  const tableRows = headerRow ? table.rows.slice(1) : table.rows;

  return (
    <div className="w-full max-w-full overflow-x-auto">
      <table className="w-full border-collapse border border-leland-gray-stroke text-left text-lg">
        {headerRow ? (
          <thead>
            <tr>
              {headerRow.cells.map((text, cellIdx) => (
                <th
                  className={`${commonCellClassName} ${headerCellClassName}`}
                  key={cellIdx}
                >
                  {text}
                </th>
              ))}
            </tr>
          </thead>
        ) : null}
        {tableRows.length ? (
          <tbody>
            {tableRows.map((row, rowIdx) => (
              <tr key={rowIdx}>
                {row.cells.map((text, cellIdx) => (
                  <td
                    className={`${commonCellClassName} ${
                      isFirstColHeader && cellIdx === 0
                        ? headerCellClassName
                        : isFirstColHeader || isFirstRowHeader
                          ? 'text-leland-gray-light'
                          : 'text-leland-gray-dark'
                    }`}
                    key={cellIdx}
                  >
                    {text}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        ) : null}
      </table>
    </div>
  );
};

export default LelandTable;

export const LelandTableHtml: FC<
  PortableTextTypeComponentProps<LelandTableProps>
> = ({ value: { table, headerRow: isFirstRowHeader } = {} }) => {
  if (!table?.rows.length) return null;

  const headerRow = isFirstRowHeader ? table.rows[0] : null;
  const tableRows = headerRow ? table.rows.slice(1) : table.rows;

  return (
    <div>
      <table>
        {headerRow ? (
          <thead>
            <tr>
              {headerRow.cells.map((text, cellIdx) => (
                <th key={cellIdx}>{text}</th>
              ))}
            </tr>
          </thead>
        ) : null}
        {tableRows.length ? (
          <tbody>
            {tableRows.map((row, rowIdx) => (
              <tr key={rowIdx}>
                {row.cells.map((text, cellIdx) => (
                  <td key={cellIdx}>{text}</td>
                ))}
              </tr>
            ))}
          </tbody>
        ) : null}
      </table>
    </div>
  );
};
